// APIのURL
const localAPI = 'https://bousai-dataeye.jp/api/';

// マップの設定
const mapConfig = {
  zoom: 14,
  minZoom: 6,
  maxZoom: 17,
  center: {
    lat: 34.39639,
    lng: 132.45944
  },
  gestureHandling: true,
  preferCanvas: true,
  zoomControl: false,
  scrollWheelZoom: true,
  baseLayers: [
    {
      name: "OpenStreetMap",
      attribution: '&copy; <a href="//osm.org/copyright">OpenStreetMap</a> contributors',
      url: "https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png",
      checked: false
    },
    {
      name: "国土地理院 - 淡色",
      attribution: "&copy; <a href='https://maps.gsi.go.jp/development/ichiran.html' target='_blank'>地理院タイル</a>",
      url: "https://cyberjapandata.gsi.go.jp/xyz/pale/{z}/{x}/{y}.png",
      checked: true
    },
    {
      name: "国土地理院 - 標準地図",
      attribution: "&copy; <a href='https://maps.gsi.go.jp/development/ichiran.html' target=\'_blank\'>地理院タイル</a>",
      url: "//cyberjapandata.gsi.go.jp/xyz/std/{z}/{x}/{y}.png",
      checked: false
    },
  ]
}

export {
  localAPI,
  mapConfig,
}